module.exports = __webpack_public_path__ + "img/Edit.c56b2463.svg";